import { createContext, useContext, useMemo, useState } from "react";

const SelectedReturnExchangesValueContext = createContext();
const SelectedReturnExchangesActionsContext = createContext();

export function SelectedReturnExchangesContextProvider({ children }) {
    const [selectedReturnExchanges, setSelectedReturnExchanges] = useState([]);

    const selectedReturnExchangesActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setSelectedReturnExchanges(newValues);
                },
                setValue: setSelectedReturnExchanges
            }
        },
        []
    )

    return (
        <>
            <SelectedReturnExchangesActionsContext.Provider value={{ selectedReturnExchanges: selectedReturnExchangesActions }}>
                <SelectedReturnExchangesValueContext.Provider value={{ selectedReturnExchanges }}>
                    {children}
                </SelectedReturnExchangesValueContext.Provider>
            </SelectedReturnExchangesActionsContext.Provider>
        </>
    );
}

export function useSelectedReturnExchangesValueContextHook(props) {
    const value = useContext(SelectedReturnExchangesValueContext);

    if (value === undefined) {
        throw new Error('useSelectedReturnExchangesValueContextHook should be used within SelectedReturnExchangesValueContext');
    }

    return {
        selectedReturnExchanges: value.selectedReturnExchanges,
    };
}

export function useSelectedReturnExchangesActionsContextHook(props) {
    const value = useContext(SelectedReturnExchangesActionsContext);

    if (value === undefined) {
        throw new Error('useSelectedReturnExchangesActionsContextHook should be used within SelectedReturnExchangesActionsContext');
    }

    return {
        selectedReturnExchanges: {
            onSet: value.selectedReturnExchanges.onSet,
            setValue: value.selectedReturnExchanges.setValue
        }
    };
}